import { render, staticRenderFns } from "./pverify-benefits-settings.vue?vue&type=template&id=f626d44c&scoped=true"
import script from "./pverify-benefits-settings.vue?vue&type=script&lang=js"
export * from "./pverify-benefits-settings.vue?vue&type=script&lang=js"
import style0 from "./pverify-benefits-settings.vue?vue&type=style&index=0&id=f626d44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f626d44c",
  null
  
)

export default component.exports